<div class="row m-3" [formGroup]="form" [id]="'section-' + personaId">
  <div class="col">
    <div class="row my-3">
      <div class="col-md-6">
        <label class="col-3 text-capitalize my-0">Persona</label>
        <nb-form-field class="col-3 px-0 mw-100">
          <nb-select fullWidth (selectedChange)="personaChanged($event)" class="input" [selected]="persona?.name">
            <nb-option [value]="persona.name" *ngFor="let persona of personas">
              {{ persona.name }}
            </nb-option>
          </nb-select>
        </nb-form-field>
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <p class="m-0"><strong> Capacity:</strong> {{ getCapacity() }}</p>
      </div>
      <span class="col">
        <mat-icon *ngIf="!persona" class="close-button" (click)="deleteSection($event)">close</mat-icon>
      </span>
    </div>
    <div class="row my-3">
      <div class="col">
        <label class="col-3 text-capitalize my-0">Section</label>
        <nb-form-field class="col-3 px-0 mw-100">
          <nb-select fullWidth (selectedChange)="sectionChanged($event)" class="input" [selected]="sectionId">
            <nb-option [value]="section.id" *ngFor="let section of sections">
              {{ section.name }}
            </nb-option>
          </nb-select>
        </nb-form-field>
      </div>
      <div class="col">
        <label class="col-3 text-capitalize my-0">Price</label>
        <nb-form-field class="col-3 px-0 mw-100">
          <nb-select fullWidth (selectedChange)="priceChanged($event)" class="input" [selected]="priceCode">
            <nb-option [value]="price.code" *ngFor="let price of prices"> {{ price.name }} - {{ price.price / 100 }} {{ persona?.currency?.name }} </nb-option>
          </nb-select>
        </nb-form-field>
      </div>
    </div>
    <div class="row my-3 align-items-center">
      <div *ngIf="barcode && connected" class="col d-flex justify-content-center">
        The barcode for your test entry is &nbsp;<span class="text-primary"> {{ barcode }}</span>
      </div>
      <div class="col d-flex justify-content-end mx-3 p-0">
        <button *ngIf="!connected && !isLoading" class="btn btn-primary align-self-end input" type="submit" (click)="onSubmit()">Connect</button>
        <button *ngIf="connected" class="btn btn-success" (click)="deleteSection()">
          <span class="connected"> <mat-icon class="check">check</mat-icon> Connected </span>
          <span class="disconnect"> <mat-icon class="check">link_off</mat-icon> Disconnect </span>
        </button>
        <button *ngIf="isLoading" class="login-btn" matButton mat-raised-button color="primary" disabled>
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
